import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) {
      navigate("/giris?hata=kod_yok", { replace: true });
      return;
    }
    loginWithToken(token)
      .then(() => navigate("/", { replace: true }))
      .catch(() => navigate("/giris?hata=oauth_basarisiz", { replace: true }));
  }, [params, navigate, loginWithToken]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <p className="text-sm text-muted-foreground">Oturum açılıyor…</p>
    </div>
  );
}
